/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import { Box, Grid } from "@mui/material";
import React from "react";
import InputField from "../../../../components/Layout/fieldInput/InputField";

function AdvancedSearch({
  amountFromValue,
  onAmountFrom,
  amountToValue,
  onAmountTo,
}) {
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      <Grid item xs={6}>
        <InputField
          label="Amount From"
          name="amountFrom"
          value={amountFromValue}
          onChange={(event) => {
            const { value } = event.target;
            onAmountFrom(value);
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <InputField
          label="Amount To"
          name="amountTo"
          value={amountToValue}
          onChange={(event) => {
            const { value } = event.target;
            onAmountTo(value);
          }}
        />
      </Grid>
    </Box>
  );
}

export default AdvancedSearch;
